import { getLocalApiUrl, authFetch } from '../../config/api'

export async function fetchMeterReconciliation(tradingDay, filters = {}) {
  const params = new URLSearchParams()
  if (tradingDay) params.set('trading_day', tradingDay)
  if (filters.machineClass && filters.machineClass !== 'all') {
    params.set('machine_class', filters.machineClass)
  }
  if (filters.egmpks?.length) params.set('egmpks', filters.egmpks.join(','))
  if (filters.hours?.length) params.set('hours', filters.hours.map(String).join(','))
  const qs = params.toString()
  const res = await authFetch(
    getLocalApiUrl(`/api/daily-data/meter/reconciliation${qs ? `?${qs}` : ''}`)
  )
  const json = await res.json()
  if (!json.success) throw new Error(json.error || 'Failed to load turnover')
  return json.data
}

export function reconChartFilters({ machineClass, selectedEgmpks, selectedHours }) {
  return {
    machineClass: machineClass || 'all',
    egmpks: selectedEgmpks || [],
    hours: selectedHours || [],
  }
}
